/*
 * Copyright (c) 2020, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { Key } from 'react';

export const CREATE_API_KEYS_CREDENTIALS_REQUEST = 'CREATE_API_KEYS_CREDENTIALS_REQUEST';
export const CREATE_API_KEYS_CREDENTIALS_SUCCESS = 'CREATE_API_KEYS_CREDENTIALS_SUCCESS';
export const CREATE_API_KEYS_CREDENTIALS_FAILURE = 'CREATE_API_KEYS_CREDENTIALS_FAILURE';

export const FETCH_API_KEYS_CREDENTIALS_REQUEST = 'FETCH_API_KEYS_CREDENTIALS_REQUEST';
export const FETCH_API_KEYS_CREDENTIALS_SUCCESS = 'FETCH_API_KEYS_CREDENTIALS_SUCCESS';
export const FETCH_API_KEYS_CREDENTIALS_FAILURE = 'FETCH_API_KEYS_CREDENTIALS_FAILURE';

export const DELETE_API_KEYS_CREDENTIALS_REQUEST = 'DELETE_API_KEYS_CREDENTIALS_REQUEST';
export const DELETE_API_KEYS_CREDENTIALS_SUCCESS = 'DELETE_API_KEYS_CREDENTIALS_SUCCESS';
export const DELETE_API_KEYS_CREDENTIALS_FAILURE = 'DELETE_API_KEYS_CREDENTIALS_FAILURE';

export interface CredentialsAction {
    type: typeof CREATE_API_KEYS_CREDENTIALS_FAILURE | typeof CREATE_API_KEYS_CREDENTIALS_REQUEST | typeof CREATE_API_KEYS_CREDENTIALS_SUCCESS
    | typeof FETCH_API_KEYS_CREDENTIALS_FAILURE | typeof FETCH_API_KEYS_CREDENTIALS_REQUEST | typeof FETCH_API_KEYS_CREDENTIALS_SUCCESS
    | typeof DELETE_API_KEYS_CREDENTIALS_FAILURE | typeof DELETE_API_KEYS_CREDENTIALS_REQUEST | typeof DELETE_API_KEYS_CREDENTIALS_SUCCESS,
    payload?: string | Key | any
}
